<div class="dimension" [class.disabled]="!isEditingEnabled">
  <div class="slidecontainer">
    <input
      #slider
      type="range"
      [disabled]="!isEditingEnabled"
      [value]="sliderValue"
      [min]="min"
      [max]="max"
      [step]="'any'"
      class="slider"
      id="slider"
      [style]="style"
      (change)="setProgressSlider($event)"
      (input)="setProgressSlider($event)"
      (mouseup)="sliderMouseUp()"
      (touchend)="sliderMouseUp()" />
  </div>
  <div class="input-container">
    <input
      [ngClass]="{ 'input-error': error }"
      #input
      class="input"
      type="number"
      [(value)]="value"
      [placeholder]="min"
      (input)="inputChanged($event.target)"
      [min]="min"
      [max]="max"
      [step]="'any'"
      [disabled]="!isEditingEnabled" />
  </div>
  <div fxLayout="column" fxLayoutAlign="center center"><span class="very-light-text">mm</span></div>
</div>
